// extracted by mini-css-extract-plugin
export default {"plate":"styles_plate__K-H-b"};